module.exports = __webpack_public_path__ + "img/logo_sidebar.5f7e7aed.png";